import DefinitionParser from './parse';
var DefinitionStore = /** @class */ (function () {
    function DefinitionStore() {
        this._store = new Map();
        this.parser = new DefinitionParser();
    }
    DefinitionStore.prototype.store = function (raw) {
        var result = this.parser.parse(raw);
        this._store.set(result.id, result);
        return result;
    };
    DefinitionStore.prototype.fetch = function (id) {
        var result = this._store.get(id);
        if (!result) {
            throw "Trying to fetch webapp definition for id " + id + ", which is not loaded.";
        }
        return result;
    };
    DefinitionStore.prototype.all = function () {
        return Array.from(this._store.values());
    };
    return DefinitionStore;
}());
export default DefinitionStore;
//# sourceMappingURL=store.js.map